import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  FilterTreeNode,
} from "../../../../services/cloudchipr.api";
import { getSavingsOpportunitiesFixedCacheKey } from "@/store/savings-opportunities/utils/helpers/fixedCacheKeys";
import { savingsOpportunitiesCurrentViewFiltersSelector } from "@/store/savings-opportunities/selectors/views-hierarchy/current-view/savingsOpportunitiesCurrentViewFiltersSelector";
import { RootState } from "@/store/store";

export const getSavingsOpportunitiesThunk = createAsyncThunk(
  "savingsOpportunities/getSavingsOpportunities",
  async (overrideFilterTree: FilterTreeNode | void, { dispatch, getState }) => {
    const { postOrganisationsCurrentSavingsOpportunities } =
      cloudChiprApi.endpoints;

    const filter =
      overrideFilterTree ??
      savingsOpportunitiesCurrentViewFiltersSelector(getState() as RootState);

    return await dispatch(
      postOrganisationsCurrentSavingsOpportunities.initiate(
        { body: { filter_tree: filter } },
        {
          fixedCacheKey: getSavingsOpportunitiesFixedCacheKey(),
        },
      ),
    ).unwrap();
  },
);
